const ADD_LOGGED_ACCOUNT = 'ADD_LOGGED_ACCOUNT';
const CLEAR_LOGGED_ACCOUNT = 'CLEAR_LOGGED_ACCOUNT';

const initialState = {
  accounts: [],
};

export const addLoggedAccount = account => ({
  type: ADD_LOGGED_ACCOUNT,
  account,
});

export const clearLoggedAccount = () => ({
  type: CLEAR_LOGGED_ACCOUNT,
});

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_LOGGED_ACCOUNT: {
      const { accounts } = state;
      const { account } = action;
      const isExisted = accounts.includes(account);
      if (!isExisted) {
        return {
          ...state,
          accounts: [...accounts, account],
        };
      }
      return {
        ...state,
      };
    }
    case CLEAR_LOGGED_ACCOUNT:
      return initialState;
    default:
      return state;
  }
};

export default accountReducer;
